"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorAndShare = void 0;
var React = require("react");
var styles_1 = require("@/pages/articleDetail/components/AuthorAndShare/styles");
var recompose_1 = require("recompose");
var Component = function (_a) {
    var newsArticleDetail = _a.newsArticleDetail;
    var data = newsArticleDetail.data, translate = newsArticleDetail.translate;
    var authorDetail = data.authorDetail;
    var viewMoreArticles = translate.viewMoreArticles, share = translate.share;
    var renderAuthorInfo = function () { return authorDetail && (React.createElement(styles_1.AuthorContainer, null,
        React.createElement(styles_1.AuthorProfileImage, { src: authorDetail.imageUrl }),
        React.createElement(styles_1.AuthorInfoContainer, null,
            React.createElement(styles_1.AuthorName, { href: authorDetail.agentUrl }, authorDetail.agentName),
            React.createElement("div", { style: { height: 8 } }),
            React.createElement(styles_1.ViewMoreArticles, { href: authorDetail.viewMoreArticlesUrl },
                React.createElement("u", null, viewMoreArticles))))); };
    return (React.createElement(styles_1.Container, null,
        React.createElement(styles_1.ShareContainer, null,
            share,
            ": ",
            React.createElement("div", { className: "addthis_inline_share_toolbox" })),
        renderAuthorInfo()));
};
var enhance = recompose_1.compose(recompose_1.lifecycle({
    componentDidMount: function () {
        var script = document.createElement('script');
        script.src = '//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5cbed109f65bc349';
        script.type = 'text/javascript';
        document.head.appendChild(script);
    },
}));
exports.AuthorAndShare = enhance(Component);
